import { AssessmentSessionProcessTypeId } from '../../services/exams/assessmentSession/assessments.types';
import Assessment from './Assessment.component';
import AssessmentAccessGuard from './AssessmentAccessGuard';

const AssessmentQualificationPage: React.FC = () => {
  const processTypeStringId = AssessmentSessionProcessTypeId.Qualification.toString();
  const processTypeId = parseInt(processTypeStringId) as AssessmentSessionProcessTypeId;

  return (
    <AssessmentAccessGuard processTypeStringId={processTypeStringId}>
      <Assessment processTypeId={processTypeId} processTypeStringId={processTypeStringId} />;
    </AssessmentAccessGuard>
  );
};

export default AssessmentQualificationPage;
